import { engagements } from './engagements'
import { operators } from './operators'
import { programs } from './programs'
import { tasks } from './tasks'

export const qualityMetrics = {
  operators,
  programs,
  tasks,
  engagements,
}
